const maxCommentLength = 150;

export const validateUserComment = (text: string): string | null => {
  if (text.length > maxCommentLength) {
    return `Max. length ${maxCommentLength} characters`;
  }
  return null;
};
